export const getDeviceSafetyZoneDefault = () => ({
  day_frequency: "0000000",
  geofence_id: "",
  leave_alert: false,
  geofence_device_id: null,
  start_time: "00:00:00",
  end_time: "23:59:59",
});
